<template lang="pug">
.tabela
    el-table(
        height='calc(100% - 57px)',
        :data='sucursales',
        @sort-change='ordenar'
    )
        el-table-column(
            prop='nome',
            :label='$t("mensagens.usuarios.tabela.nome")',
            min-width='300',
            sortable
        )
        el-table-column(
            prop='documento',
            label='CUIT',
            min-width='300'
        )
            template(slot-scope='scope')
                span {{ formatarCuit(scope.row.documento) }}
        el-table-column(
            prop='ativo',
            label='Status',
            min-width='300',
            sortable
        )
            .template(slot-scope='scope')
                div(
                    :class='[scope.row.ativo ? "verificado" : "nao-verificado"]'
                )
                    | {{ scope.row.ativo ? $t('mensagens.usuarios.tabela.statusUsuario.ativo') : $t('mensagens.usuarios.tabela.statusUsuario.inativo') }}

        el-table-column(
            min-width='100',
            align='center',
            :label='$t("mensagens.usuarios.tabela.acoes.label")'
        )
            .template(slot-scope='scope')
                el-dropdown.acoes(trigger='click')
                    span.el-dropdown-link
                        i.mdi.mdi-dots-vertical

                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-edit',
                            @click.native='abrirModalEditarSucursal(scope.row)'
                        )
                            | {{ $t('mensagens.usuarios.tabela.acoes.editar') }}
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                                :icon='scope.row.ativo ? "el-icon-remove-outline" : "el-icon-circle-check"',
                                @click.native='acaoAlterarStatus(scope.row)'
                            )
                                | {{ scope.row.ativo ? $t('mensagens.usuarios.tabela.acoes.desativar') : $t('mensagens.usuarios.tabela.acoes.ativar') }}

    .py-3.btn-paginacao(style='text-align: center')
        el-pagination(
            background,
            :page-size='20',
            :current-page.sync='paginaLocal.page',
            layout='prev, pager, next',
            :total='totalSucursales',
            @current-change='onPageChange'
        )

    el-dialog.modal-altera-status(
        :visible.sync='mostrarModalAlterarStatus',
        width='500px',
        :before-close='alterarModalAlterarStatus'
    )
        h2 {{ !alterarStatusSucursal.status ? $t('mensagens.sucursales.ativar') : $t('mensagens.sucursales.desativar') }} {{ alterarStatusSucursal.nome.trim() + '?' }}
        footer(slot='footer')
            el-button(size='mini', @click='alterarModalAlterarStatus') {{ $t('mensagens.comuns.cancelar') }}
            el-button(size='mini', type='primary', @click='alterarStatus') {{ !alterarStatusSucursal.status ? $t('mensagens.usuarios.editarUsuario.botaoHabilitar') : $t('mensagens.usuarios.editarUsuario.botaoDesabilitar') }}
</template>

<script>
import SucursaleService from '@/services/SucursaleService';
import formatters from '@/utils/formatters';

export default {
    name: 'TabelaSucursales',
    props: {
        sucursales: {
            type: Array,
            default: () => []
        },
        totalSucursales: {
            type: Number,
            default: 0
        },
        pagina: {
            type: Object,
            default: () => ({ page: 1, filter: '' })
        }
    },
    data() {
        return {
            paginaLocal: { ...this.pagina },
            mostrarModalAlterarStatus: false,
            alterarStatusSucursal: {
                nome: '',
                status: false
            }
        };
    },
    watch: {
        pagina: {
            handler(newVal) {
                this.paginaLocal = { ...newVal };
            },
            deep: true
        }
    },
    methods: {
        ordenar(sortInfo) {
            this.$emit('ordenar', sortInfo);
        },
        abrirModalEditarSucursal(sucursal) {
            this.$emit('abrirModalEditarSucursal', sucursal);
        },
        reenviarEmail(sucursal) {
            this.$emit('reenviarEmail', sucursal);
        },
        acaoAlterarStatus({ id, ativo, nome }) {
            this.alterarStatusSucursal = {
                id,
                nome: nome,
                status: ativo
            };
            this.alterarModalAlterarStatus();
        },
        onPageChange(page) {
            this.paginaLocal.page = page;
            this.$emit('changePage', page);
        },
        formatarCuit(cuit) {
          return formatters.formatarCuit(cuit);
        },
        alterarModalAlterarStatus() {
            this.mostrarModalAlterarStatus = !this.mostrarModalAlterarStatus;
        },
        alterarStatus() {
            SucursaleService.changeEnabled(
                this.alterarStatusSucursal.id,
                !this.alterarStatusSucursal.status
            )
                .then(() => {
                    this.$notify.success({
                        message: this.alterarStatusSucursal.status
                            ? this.$t(
                                  'mensagens.usuarios.sucursalInativadoSucesso'
                              )
                            : this.$t(
                                  'mensagens.usuarios.sucursalAtivadoSucesso'
                              )
                    });
                    this.alterarModalAlterarStatus();
                    setTimeout(() => {
                        this.$emit('refetchSucursales');
                    }, 1000);
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.sucursales.erroInativar')
                    });
                });
        },
        getRoleTraduzido(role) {
            if (role != null) {
                switch (role) {
                    case 'Gestor':
                        return this.$t('mensagens.sucursals.perfil.gestor');
                    case 'Regular':
                        return this.$t('mensagens.sucursals.perfil.regular');
                    case 'Administrador':
                        return this.$t('mensagens.sucursals.perfil.administrador');
                    case 'Assistente':
                        return this.$t('mensagens.sucursals.perfil.assistente');
                    default:
                        return role;
                }
            }
            return '';
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela {
    border-radius: 5px;
    overflow: hidden;
    background-color: var(--white);
    height: calc(100vh - 258px);
    width: 100%;
    padding-top: 0 !important;
    padding-bottom: 0 !important;

    .acoes:hover {
        cursor: pointer;
    }
}

.nome {
    em {
        font-size: 12px;
        background-color: #d1ead2;
        border: 1px solid #bae0bc;
        border-radius: 4px;
        padding: 0 4px;
        margin-left: 8px;
    }
}

.verificado,
.nao-verificado,
.ativo,
.inativo {
    border-radius: 20px;
    text-align: center;
    max-width: 120px;
    color: var(--black);
}

.verificado,
.ativo {
    background-color: #d1ead2;
    border: 1px solid #bae0bc;
}

.nao-verificado,
.inativo {
    background-color: #ffaeae;
    border: 1px solid var(--danger);
}

.pagination {
    background-color: var(--white);
    border-radius: 0 0 2px 2px;
    justify-content: center;
}
</style>
